<template>
  <div>
    <!-- Button Add New auction -->
    <div style="float: right">
      <md-button
        class="md-icon-button md-primary md-simple new-app-button"
        style="padding: 10px"
        @click="openAuctionItemForm({})"
      >
        <md-icon id="new-app-icon">
          note_add
        </md-icon>
          New Auction
        <md-tooltip md-direction="top">
          Add new auction
        </md-tooltip>
      </md-button>

      <md-button
        class="md-icon-button md-primary md-simple new-app-button"
        style="padding: 10px"
        @click="openAuctionCycleForm()"
      >
          Adjust Cycle
        <md-tooltip md-direction="top">
          Adjust Auction Cycle Duration
        </md-tooltip>
      </md-button>

      <loading-icon-button
        tooltip="Refresh"
        style="padding: 10px"
        @click="getAuctionList"
      >
        refresh
      </loading-icon-button>
    </div>
    <!-- Edit Form for Auction -->
    <md-dialog :md-active.sync="showAuctionEditForm">
      <ValidationObserver v-slot="{ invalid }">
        <div class="dialogWrapper">
          <md-dialog-title>
            {{ isNewAuctionObject ? 'Create an auction' : 'Edit ' + auction.name  }}
          </md-dialog-title>
          <br />
          <div class="md-layout">
            <validated-text-input
              class="md-layout-item"
              v-model="auction.name"
              label="Name"
              errormsg="This field is required"
              required
            />
            <validated-autocomplete-input
              class="md-layout-item"
              label="Grade A"
              v-model="auction.grade_a"
              :options="options.all_billing_types"
              required
            />
            <validated-autocomplete-input
              class="md-layout-item"
              label="Grade B"
              v-model="auction.grade_b"
              :options="options.all_billing_types"
              required
            />
          </div>
          <div class="md-layout">
            <validated-autocomplete-input
              class="md-layout-item"
              label="Grade C"
              v-model="auction.grade_c"
              :options="options.all_billing_types"
              required
            />
            <validated-autocomplete-input
              class="md-layout-item"
              label="Buy now fee"
              v-model="auction.buy_now"
              :options="options.all_billing_types"
            />
            <validated-number-input
              class="md-layout-item"
              v-model="auction.auction_timer"
              label="Auction Timer (Minutes)"
              errormsg="This field is required and must be a number"
              required
            />
            <validated-number-input
              class="md-layout-item"
              v-model="auction.restart_timer"
              label="Restart Timer (Minutes)"
              errormsg="This field is required and must be a number"
              required
            />
            <validated-number-input
              class="md-layout-item"
              v-model="auction.close_timer"
              label="Close Timer (Minutes)"
              errormsg="This field is required and must be a number"
              required
            />
          </div>
          <div class="md-layout">
            <validated-text-input
              class="md-layout-item"
              v-model="auction.description"
              label="Description"
              errormsg="This field is required"
              required
            />
          </div>
          <div v-if="invalid">
            <p class="error-message">Please enter valid data to save changes</p>
          </div>
          <md-dialog-actions>
            <md-button
              class="md-primary md-simple"
              @click="cancelAuctionItemForm"
            >
              Cancel
            </md-button>
            <md-button
              class="md-primary"
              :disabled="isAuctionFormDisable(invalid)"
              @click="saveAuctionItemForm()"
            >
              {{ isNewAuctionObject ? 'Save' : 'Update' }}
            </md-button>
          </md-dialog-actions>
        </div>
      </ValidationObserver>
    </md-dialog>

    <!-- Edit Form for Cycle Time -->
    <md-dialog :md-active.sync="showAuctionCycleForm">
      <ValidationObserver v-slot="{ invalid }">
        <div class="dialogWrapper">
          <md-dialog-title>
            Edit Auction Cycle Duration
          </md-dialog-title>
          <br />

          <!-- Day of the Week Selector -->
          <div class="md-layout-item">
            <validated-autocomplete-input
              class="md-layout-item"
              label="Start Day"
              v-model="auctionCycleTime.startDay"
              :options="daysOfWeek"
              required
            />
          </div>

          <!-- Time Picker -->
          <div class="md-layout-item">
            <label for="start-time">Start Time</label>
            <input
              type="time"
              v-model="auctionCycleTime.startTime"
              required
            />
          </div>

          <!-- Day of the Week Selector -->
          <div class="md-layout-item">
            <validated-autocomplete-input
              class="md-layout-item"
              label="End Day"
              v-model="auctionCycleTime.endDay"
              :options="daysOfWeek"
              required
            />
          </div>

          <div class="md-layout-item">
            <label for="end-time">End Time</label>
            <input
              type="time"
              v-model="auctionCycleTime.endTime"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-number-input
              class="md-layout-item"
              label="Price Reduction Cycle"
              v-model="auctionCycleTime.priceReductionCycle"
              :min-value="0"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-number-input
              class="md-layout-item"
              label="Reduction Price"
              v-model="auctionCycleTime.reductionPrice"
              :min-value="0"
              :prefix="'$'"
              required
            />
          </div>

          <div v-if="invalid">
            <p class="error-message">Please enter valid data to save changes</p>
          </div>
          <md-dialog-actions>
            <md-button
              class="md-primary md-simple"
              @click="closeAuctionCycleForm"
            >
              Cancel
            </md-button>
            <md-button
              class="md-primary"
              @click="saveAuctionCycle"
            >
              Save
            </md-button>
          </md-dialog-actions>
        </div>
      </ValidationObserver>
    </md-dialog>

    <data-table
      :headers="auctionServiceHeaders"
      v-model="auctionServicesData"
      :items-per-page="10"
      title="Auctions Services"
      filterable
    >
      <template v-slot:item.auction_action="{ item }">
        <LoadingIconButton
          tooltip="Edit this Auction"
          @click="openAuctionItemForm(item)"
        >
          edit
        </LoadingIconButton>
        <LoadingIconButton
          tooltip="Delete this Auction"
          @click="deleteAuctionItem(item)"
        >
          clear
        </LoadingIconButton>
      </template>
    </data-table>
    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
  components: {
    DataTable,
    LoadingIconButton,
    ...ValidatedInputs,
  },
  created() {
    this.getAuctionList();
    this.getAuctionCycleTime();
  },
  data() {
    return {
      isNewAuctionObject: false,
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      showAuctionEditForm: false,
      auction: {},
      originalAuctionItem: {}, //initial state Auction when page is loaded
      auctionServiceHeaders: [
        {
          text: "Id",
          value: "id",
          sort: true,
        },
        {
          text: "Name",
          value: "name",
          sort: true,
          search: true
        },
        {
          text: "Description",
          value: "description",
          sort: true,
        },
        {
          text: "Grade A",
          value: "grade_a",
          sort: true,
        },
        {
          text: "Grade B",
          value: "grade_b",
          sort: true,
        },
        {
          text: "Grade C",
          value: "grade_c",
          sort: true,
        },
        {
          text: "Timer (Minutes)",
          value: "auction_timer",
          sort: false,
        },
        {
          text: "Buy now fee",
          value: "buy_now",
          sort: false,
        },
        {
          text: "Action",
          value: "auction_action",
          sort: false,
        },

      ],
      auctionServicesData: [],
      auctionCycleTime: {
        startDay: '',
        startTime: '',
        endDay: '',
        endTime: '',
        priceReductionCycle: 0,
        reductionPrice: 0,
      },
      daysOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],
      showAuctionCycleForm: false,
    };
  },
  methods: {
    isAuctionFormDisable(invalid) {
      // check for modifying and validation data
      if (JSON.stringify(this.auction) === JSON.stringify(this.originalAuctionItem) || invalid)
        return true;

      return false;
    },
    async getAuctionList() {
      await axios.get(`/api/v1/administration/zink_auction_services`)
        .then(res => {
          this.auctionServicesData = res.data;
        })
        .catch(err => {
          console.log("Error getting auctionServicesData", err);
          this.showUserDialog("Seems like a small problem with getting data..", err.response.data.error);
        });
    },
    showUserDialog(title, message) {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
    },
    openAuctionItemForm(selectedAuctionItem) {
      // we understand new or existing object to save
      this.isNewAuctionObject = (Object.keys(selectedAuctionItem).length === 0) ? true : false;
      // add into object nullable fields, otherwise will get eloquent error
      if (selectedAuctionItem['buy_now'] === undefined) {
        selectedAuctionItem['buy_now'] = '';
      }
      this.auction = selectedAuctionItem;
      this.originalAuctionItem = { ...selectedAuctionItem };
      this.showAuctionEditForm = true;
    },
    openAuctionCycleForm() {
      this.showAuctionCycleForm = true;
    },
    async deleteAuctionItem(selectedAuctionItem) {
      await axios.delete(`/api/v1/administration/zink_auction_services/${selectedAuctionItem.id}`)
        .then(res => {
          // if success need a fresh list
          this.getAuctionList();
          this.showUserDialog(`${selectedAuctionItem.name} Auction has been deleted!`, "");
        })
        .catch(err => {
          console.error("Delete Auction Item request failed", err);
          this.showUserDialog("Seems like a small problem with deleting this auction...", err.response.data.error);
        });
    },
    async saveAuctionItemForm() {
      // we have a new object
      if (this.isNewAuctionObject) {
        await axios.post(`/api/v1/administration/zink_auction_services`, this.auction)
          .then(res => {
            this.showUserDialog("Сongratulations", `${this.auction.name} auction has been created with a ${this.auction.auction_timer} minute timer.`);
            // if success need a fresh list
            this.getAuctionList();
          })
          .catch(err => {
            console.error("Create New Auction form request failed", err);
            this.showUserDialog("Seems like a small problem with creating a new auction...", err.response.data.error);
          });
      }
      else {
        // we have an updated object
        await axios.patch(`/api/v1/administration/zink_auction_services/${this.auction.id}`, this.auction)
          .then(res => {
            this.showUserDialog(`${this.auction.name} auction has been updated.`, "");
          })
          .catch(err => {
            console.error("Failed to complete the request to update the auction edit form.", err);
            this.showUserDialog("Seems like a small problem with updating this auction edit form...", err.response.data.error);
            // if failed must return original state of the form
            this.getAuctionList();
          });
      }
      this.showAuctionEditForm = false;
    },
    cancelAuctionItemForm() {
      // if cancel clicked and form has been modified, must return original state of the form
      if (JSON.stringify(this.auction) !== JSON.stringify(this.originalAuctionItem)) {
        this.getAuctionList();
      }
      this.showAuctionEditForm = false;
    },
    closeAuctionCycleForm() {
      this.showAuctionCycleForm = false;
    },
    async saveAuctionCycle() {
      try {
        await axios.post(`/api/v1/auction_cycle_time`,
          {
            'auctionStartDate': this.auctionCycleTime.startDay,
            'auctionStartTime': this.auctionCycleTime.startTime,
            'auctionEndDate': this.auctionCycleTime.endDay,
            'auctionEndTime': this.auctionCycleTime.endTime,
            'priceReductionCycle': this.auctionCycleTime.priceReductionCycle,
            'reductionPrice': this.auctionCycleTime.reductionPrice,
          }
        );
        this.showUserDialog("New auction cycle have been update sucessfully");
      } catch (err) {
        this.showUserDialog("Seems like a small problem with saving the auction cycle", err.response.data.error);
      } finally {
        this.showAuctionCycleForm = false;
      }
    },
    async getAuctionCycleTime() {
      try {
        const response = await axios.get(`/api/v1/auction_cycle_time`);
        this.auctionCycleTime.startDay = response.data.auctionStartDate;
        this.auctionCycleTime.startTime = response.data.auctionStartTime;
        this.auctionCycleTime.endDay = response.data.auctionEndDate;
        this.auctionCycleTime.endTime = response.data.auctionEndTime;
        this.auctionCycleTime.priceReductionCycle = response.data.priceReductionCycle;
        this.auctionCycleTime.reductionPrice = response.data.reductionPrice;
      } catch (err) {
        console.log(err);
      }
    },
    ...filters
  },
  computed: {
    ...mapGetters([
      'options',
    ]),

  },
  filters: {
    ...filters
  },
  async beforeCreate() {
    const params = {
      types: [
        'all_billing_types',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.dialogWrapper {
  padding: 30px;
}

.error-message {
  color: red;
  padding: 6px;
  margin: 15px 30px;
  text-align: center;
}
</style>
